<template>
  <div>
    <div class="row">
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Fragrance name</label>
          <el-input placeholder="Input data"
                    v-model="localFilters.fragranceDetails.fragranceName.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper show-animation" :class="{'show': localFilters.fragranceDetails.creative.value}">
          <label v-b-tooltip.hover.html="tooltips.perfumerRefNumber">Perfumer name</label>
          <el-select
              v-model="localFilters.fragranceDetails.perfumerName.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getFragranceTagValues('perfumer_name')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>SAP #</label>
          <el-input placeholder="Input data"
                    v-model="localFilters.fragranceDetails.sapNumber.value"
                    clearable></el-input>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Region of the fragrance</label>
          <el-select
            :value="localFilters.fragranceDetails.region.value"
            @change="val => changeRegionData(val, 'fragranceDetails')"
            placeholder="Select data" multiple filterable collapse-tags>
              <el-option-group label="Press Tab/Escape to exit">
                <template v-for="value in getFragranceTagValues('region')">
                  <el-option
                      v-if="!['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia'].includes(value.value)"
                      :key="value.value"
                      :label="value.value"
                      :value="value.value">
                    <span style="float: left">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                </template>
                <template v-for="value in getAPACcounts('fragrance')">
                  <el-option v-if="value.value === 'APAC'" :key="value.value" :label="value.value"
                             :value="value.value">
                    <span style="float: left">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                  <el-option v-else :key="value.value" :label="value.value"
                             :value="value.value">
                    <span style="float: left; margin-left: 10px">{{value.value}}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
                  </el-option>
                </template>
              </el-option-group>
            </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Benchmark/Creative</label>
          <el-select
              v-model="localFilters.fragranceDetails.creative.value"
              placeholder="Select value">
            <el-option :label="'Benchmark'" :value="false">
              <span style="float: left; margin-left: 10px">Benchmark</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ getBenchmarkCreativeCount('Benchmark') }}
              </span>
            </el-option>
            <el-option :label="'Creative'" :value="true">
              <span style="float: left; margin-left: 10px">Creative</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ getBenchmarkCreativeCount('Creative') }}
              </span>
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6 d-flex flex-column align-items-center">
        <div class="input-wrapper">
          <label>Family</label>
          <el-select
              v-model="localFilters.fragranceDetails.family.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getFragranceTagValues('family')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Subfamily</label>
          <el-select
              v-model="localFilters.fragranceDetails.subfamily.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getFragranceTagValues('subfamily')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Specifier</label>
          <el-select
              v-model="localFilters.fragranceDetails.specifier.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getFragranceTagValues('specifier')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="input-wrapper" style="margin-top: 17px">
          <label>Country of the fragrance</label>
          <el-select
              v-model="localFilters.fragranceDetails.country.value" collapse-tags
              placeholder="Select values" filterable multiple @change="updateDropdownValues(localFilters)"
          >
            <el-option-group label="Press Tab/Escape to exit">
              <el-option
                  v-for="value in getFragranceTagValues('country')"
                  :key="value.value" :label="value.value" :value="value.value">
                <span style="float: left">{{value.value}}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{value.count}}</span>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tooltips from '../../../constants/tooltips'
import _ from 'lodash'

export default {
  name: 'FragranceDetailsForm',
  emits: ['update:filters'],
  props: {
    filters: Object,
    getMetadataTagValues: Function,
    updateDropdownValues: Function,
    getFragranceTagValues: Function,
    getAPACcounts: Function,
    getBenchmarkCreativeCount: Function
  },
  data () {
    return {
      tooltips,
      localFilters: _.cloneDeep(this.filters),
      previousRegionValues: [],
      oldPerfumeNameValue: ''
    }
  },
  methods: {
    changeRegionData (data, targetObj) {
      const mainRegion = 'APAC'
      const subRegions = ['APAC-South Asia', 'APAC-South East Asia', 'APAC-North Asia']
      if (data.includes(mainRegion)) {
        if (!this.previousRegionValues.includes(mainRegion)) {
          data = [...new Set([...data, ...subRegions])]
        } else {
          if (data.filter(el => el !== mainRegion).length < 3) {
            const index = data.indexOf(mainRegion)
            data.splice(index, 1)
          }
        }
      } else {
        if (this.previousRegionValues.includes(mainRegion)) {
          data = data.filter(x => !subRegions.includes(x))
        }
      }
      this.$set(this.localFilters[targetObj].region, 'value', data)
      this.previousRegionValues = data
      this.updateDropdownValues(_.cloneDeep(this.localFilters))
    }
  },
  watch: {
    filters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.localFilters)) {
          this.localFilters = _.cloneDeep(value)
        }
      }
    },
    localFilters: {
      deep: true,
      handler (value) {
        if (!_.isEqual(value, this.filters)) {
          this.$emit('update:filters', _.cloneDeep(value))
        }
      }
    },
    'localFilters.fragranceDetails.creative.value': function (newValue, oldValue) {
      if (newValue) {
        if (this.localFilters.fragranceDetails.perfumerName.value) {
          this.oldPerfumeNameValue = this.localFilters.fragranceDetails.perfumerName.value
        }
        this.localFilters.fragranceDetails.perfumerName.value = ''
      } else {
        this.localFilters.fragranceDetails.perfumerName.value = this.oldPerfumeNameValue
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.unchecked-text {
  color: rgba(0, 0, 0, 0.15) !important;
  transition: .3s;
}

.checked-creative {
  color: rgb(0, 39, 204);
  transition: .3s;
}

.checked-benchmark {
  color: rgb(115, 178, 224);
  transition: .3s;
}

.show-animation {
  overflow: hidden;
  max-height: 0;
  transform: scaleY(0);
  transition: 0.3s linear;
  margin-top: 0;
  &.show {
    margin-top: 17px;
    max-height: 500px;
    transform: scaleY(1);
    transition: 0.3s linear;
    margin-bottom: 0 !important;
  }
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

.input-wrapper input {
  width: 100%;
}

.input-wrapper .el-select {
  width: 100%;
}

.input-wrapper label {
  color: $input-label;
  margin-bottom: 2px;
  margin-left: 2px;
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 13px;
  line-height: 20px;
  font-weight: 600;
}
</style>
